"use client";

import { Dispatch, SetStateAction } from "react";
import { Body } from "./Body";
import styles from "./DesignPreview.module.scss";
import DesignPreviewDialog from "./DesignPreviewDialog";
import StyleSettingIcons from "./StyleSettingIcons";

type Props = {
	bodyId: string | undefined;
	showPalette: boolean;
	setShowPalette: Dispatch<SetStateAction<boolean>>;
	setShowPartMove: Dispatch<SetStateAction<boolean>>;
	showPartMove: boolean;
};

/**
 * デザインプレビュー コンポーネント
 * @returns {JSX.Element} デザインプレビュー コンポーネント
 */
export default function DesignPreview(props: Props) {
	const { bodyId, setShowPalette, setShowPartMove } = props;

	return (
		<div className={styles.designPreviewContainer}>
			<div className={styles.partImage}>
				<Body />
			</div>

			<div className={styles.displayIcon}>
				<StyleSettingIcons
					setShowPalette={setShowPalette}
					setShowPartMove={setShowPartMove}
				/>
			</div>

			<DesignPreviewDialog
				bodyId={bodyId}
				setShowPalette={setShowPalette}
			/>
		</div>
	);
}
